export default __webpack_public_path__ + "static/media/automotusLogoBlue.5c9640e0.svg";